import type React from 'react';

export interface ModeToggleButtonProps {
    active: boolean;
    disabled?: boolean;
    label: string;
    onClick: () => void;
    children: React.ReactNode;
}

export const ModeToggleButton = (props: ModeToggleButtonProps) => (
    <button
        disabled={props.disabled}
        type='button'
        aria-label={props.label}
        title={props.label}
        className={`${props.active ? 'bg-brand-primary text-background-surface border-brand-primary' : 'text-brand-primary border-border-default'} hover:border-brand-secondary disabled:text-brand-muted disabled:border-brand-disabled flex h-8 items-center justify-center rounded-md border px-2.5 text-sm font-medium disabled:cursor-not-allowed`}
        onClick={props.onClick}>
        {props.children}
    </button>
);
